<template>
  <div>
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Τμήμα και Ρόλος Χρήστη
      </h3>
      <div class="col-md-12">
        <div class="mb-3">
          <label class="mt-3">Τμήμα</label>
          <multiselect placeholder="Επιλογή τμημάτων" track-by="id" label="name" :options="departmentNames"
            :multiple="true" v-model="departmentValue" selectLabel="Eπιλογή Τμήματος" selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"></multiselect>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="mt-3">Ρόλος*</label>
        <multiselect track-by="role_id" label="role_name" v-model="roleValue" :options="rolesOptions"
          placeholder="Επιλέξτε Ρόλο" selectLabel="Eπιλογή Ρόλου" selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή">
        </multiselect>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <label class="mt-3">Δευτερεύον ρόλος</label>
          <input v-model="secondaryRole" required type="text" class="form-control" placeholder="Δευτερεύον ρόλος" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="mt-2">Σχέση Εργασίας*</label>
          <multiselect required v-model="relationshipValue" :options="employmentRelationshipOptions" track-by="id"
            label="name" placeholder="Επιλέξτε Σχέση Εργασίας" selectLabel="Eπιλογή Σχέση Εργασίας"
            selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή"></multiselect>
        </div>
        <hr />
      </div>
      <h4 class="card-title">Σύμβαση</h4>
      <div class="row">
        <div class="col-md-5">
          <div class="mb-3">
            <label class="mt-3">Από*</label>
            <b-form-input id="example-input" v-model="contract.start_date" type="date" placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY" autocomplete="off"></b-form-input>
          </div>
        </div>
        <div class="col-md-5">
          <div class="mb-3">
            <label class="mt-3">Μέχρι*</label>
            <b-form-input id="example-input" v-model="contract.end_date" type="date" placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY" autocomplete="off"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label>Σχόλια:</label>
            <input v-model="contract.comments" required type="text" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" @click.prevent="updatePerson">
      Ενημέρωση
    </button>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import session from "../../../../api/session";
import { translateRole } from "../../../../translate_roles";
import { eventCreate } from "../../../../eventspy.js";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      userForm: {},
      userDetails: [],
      departmentValue: "",
      roleValue: "",
      relationshipValue: "",
      contract: [],
      secondaryRole: "",
      oldUserForm: {},
    };
  },
  mounted() {
    this.fetchUpdatedPerson();
    this.fetchUserDetails();
  },
  computed: {
    ...mapState("utils", [
      "employmentRelationShips",
      "departmentOptions",
      "roleChoices",
      "departments",
      "roles",
    ]),
    rolesOptions() {
      return this.roleChoices;
    },

    employmentRelationshipOptions() {
      return this.employmentRelationShips.map((e) => {
        return { id: e.id, name: e.title };
      });
    },
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
  },
  methods: {
    async fetchUpdatedPerson() {
      await session
        .get(`api/person/${this.$route.params.id}/update/`)
        .then((resp) => {
          this.userForm = resp.data;
          this.oldUserForm = resp.data;
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    async fetchUserDetails() {
      await session
        .get(`api/user/${this.$route.params.id}`)
        .then((resp) => {
          this.userDetails = resp.data;

          this.contract =
            Object.keys(resp.data.contract).length > 0 ? resp.data.contract : [];
          this.departmentValue = resp.data.department.map((e) => {
            return { id: e.id, name: e.department_parent_name };
          });
          this.roleValue = {
            role_id: resp.data.role_choice,
            role_name: translateRole(resp.data.role),
          };
          this.relationshipValue = {
            id: resp.data.relationship.id,
            name: resp.data.relationship.title,
          };

          this.secondaryRole = resp.data.secondary_role;
        })
        .catch((e) => {
          console.log(e.response.data);
          this.$toastr.e(JSON.stringify(e.response.data));
        });
    },

    updatePerson() {
      if (
        !this.roleValue ||
        this.departmentValue.length == 0 ||
        !this.relationshipValue
      ) {
        this.$toastr.e("Παρακαλώ συμπληρώστε όλα τα απαραίτητα πεδία!");
        return;
      }
      this.fetchUpdatedPerson().then(() => {
        this.userForm = {
          ...this.userForm,
          role: this.roleValue.role_id,
          department: this.departmentValue.map((e) => e.id),
          relationship: this.relationshipValue.id,
          secondary_role: this.secondaryRole,
        };

        session
          .put(`api/person/${this.$route.params.id}/update/`, this.userForm)
          .then(() => {
            this.$store.dispatch("utils/fetchDepartmentOptions");
            this.$toastr.Add({
              name: "UniqueToastName",
              title: `Ενημέρωση ${this.userForm.user.username}`,
              msg: "Τα στοιχεία Τμήμα και Ρόλος Χρήστη ανανεώθηκαν επιτυχώς!",
              style: { backgroundColor: "#4fd69c", width: "550px" },
              progressbar: false,
              timeout: 2000,
            });

            this.$store.dispatch("utils/fetchDepartmentOptions");

            this.historicalCreate();

            eventCreate(
              `Επεξεργασία Τμήμα και ρόλος :
            old =  ${JSON.stringify(this.oldUserForm)}
            ---------------------------------
            useform = ${JSON.stringify(this.userForm)}
             `,
              2
            );

            if (this.contract.length == 0) {
              session
                .post(`api/contract/create/`, {
                  start_date: this.contract.start_date,
                  end_date: this.contract.end_date,
                  person: this.$route.params.id,
                })
                .then((resp) => {
                  eventCreate(
                    `Δημιουργία Σύμβασης :
                  ${JSON.stringify(resp.data)}
                  `,
                    1
                  );
                });
            } else {
              session
                .put(`api/contract/${this.contract.id}/update/`, this.contract)
                .then((resp) => {
                  eventCreate(
                    `Επεξεργασία Σύμβασης :
                    old =  ${JSON.stringify(this.userDetails.contract)}
                    ---------------------------------
                    useform = ${JSON.stringify(resp.data)}
                    `,
                    2
                  );
                  this.$store.dispatch("utils/fetchDepartmentOptions");

                  this.fetchUpdatedPerson();
                  this.fetchUserDetails();
                })
                .catch((e) => {
                  console.log(e, "Σύμβαση");
                });
            }
          })
          .catch((e) => {
            this.$toastr.e(JSON.stringify(e.response.data));
          });
      });
    },

    historicalCreate() {
      const currentDepartments = this.departmentValue.map((e) => e.id);
      const oldDepartments = this.oldUserForm.department;
      const hasDifferentDepartments = oldDepartments
        .map((dep) => currentDepartments.includes(dep))
        .every((v) => v === true);

      const currentRole = this.roleValue.role_id;
      const oldRole = this.oldUserForm.role;

      const currentRelationship = this.relationshipValue.id;
      const oldRelationship = this.oldUserForm.relationship;

      if (
        !hasDifferentDepartments ||
        currentRole != oldRole ||
        currentRelationship != oldRelationship
      ) {
        session
          .post("api/historical/create/", {
            person: this.$route.params.id,
            relationship: oldRelationship,
            role: oldRole,
            department: oldDepartments,
          })
          .then(() => {
            console.log("historical created");
          });
      }
    },
  },
};
</script>
